<template>
  <div class="steps-left">
    <div class="step step-1">
      <img
        class="step-icon"
        src="@/assets/icons/screen-doodle.svg"
      >
      <div>
        <p class="step-info">
          <strong>1.Browse</strong>
        </p>
        <p class="step-info">
          Select one of our amazing templates below.
        </p>
      </div>
    </div>
    <div class="step step-2">
      <img
        class="step-icon"
        src="@/assets/icons/template-doodle.svg"
      >
      <div>
        <p class="step-info">
          <strong>2. Preview</strong>
        </p>
        <p class="step-info">
          We'll fill it with your brand, products and content.
        </p>
      </div>
    </div>
    <div class="step step-3">
      <img
        class="step-icon"
        src="@/assets/icons/email-doodle.svg"
      >
      <div>
        <p class="step-info">
          <strong>3. Edit & Send</strong>
        </p>
        <p class="step-info">
          Tweak content & layout in our simple editor before sending.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepsLeft"
};
</script>

<style scoped>
.steps-left {
  @apply flex flex-wrap justify-center;
}

.step {
  @apply bg-grey rounded-lg p-2 flex items-center shadow mb-3;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    178deg,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 0.7) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e5e5e5',GradientType=0 );
  max-width: 233px;

  @screen sm {
    @apply mx-2 py-2;
  }

  @screen lg {
    @apply mb-0;
  }

  &:last-child {
    .step-info {
      @apply mb-0;
    }
  }
}

.step-1 {
  transform: rotate(-0.4deg);

  .step-icon {
    transform: rotate(-2deg);
  }
}
.step-2 {
  transform: rotate(0.2deg);

  .step-icon {
    transform: rotate(1deg);
  }
}
.step-3 {
  transform: rotate(-0.6deg);

  .step-icon {
    transform: rotate(-2deg);
  }
}

.step-icon {
  @apply mb-0;
  margin-right: 8px;
  width: 34px;
}

.step-info {
  @apply text-support-light mb-0 text-left;
  font-size: 11px;
  text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.5);

  @screen sm {
    font-size: 12px;
  }
}
</style>